import { colorList } from "../constants/index";
function colorGenerator(index) {
  return colorList[index];
}

export { colorGenerator };
